import classnames from 'classnames';
import React from 'react';

import { AssetV2 } from '../AssetV2';
import { PopupBuilderAssetContentSection } from '../contentTypes';
import { Div } from '../HTMLElement';
import { buildSpacingClassNamesFromContent, buildVisibilityClassNamesFromContent } from '../util';
import { PropsWithCustomComponent, VariantsController } from '../VariantsController';

export interface PopupBuilderAssetComponentProps extends PopupBuilderAssetContentSection {}

const PopupBuilderAssetComponent = ({ asset, options }: PopupBuilderAssetComponentProps) => {
  const alignment = options?.alignment;
  const margin = options?.margin && buildSpacingClassNamesFromContent('m', options.margin);
  const visibility = options?.visibility;
  const visibilityClassNames = visibility && buildVisibilityClassNamesFromContent(visibility);

  return (
    <React.Fragment>
      {options?.enabled && (
        <Div
          className={classnames('popup-builder-asset-component', options.classes)}
          display="flex"
          style={{
            height: options.size?.height ? `${options.size.height}px` : undefined,
            width: options.size?.width ? `${options.size.width}px` : undefined,
          }}
          uiClassName={{
            bs5: classnames(margin, visibilityClassNames, {
              'ml-auto': alignment === 'end',
              'mr-auto': alignment === 'start',
              'mx-auto': alignment === 'center',
            }),
          }}
        >
          <AssetV2 {...asset} fluid />
        </Div>
      )}
    </React.Fragment>
  );
};

export type PopupBuilderAssetComponentVariants = '';

const PopupBuilderAssetComponentController = (props: PropsWithCustomComponent<PopupBuilderAssetComponentProps>) => (
  <VariantsController<PopupBuilderAssetComponentProps, PopupBuilderAssetComponentVariants>
    {...props}
    variantsControllerConfig={{
      defaultComponent: PopupBuilderAssetComponent,
      name: 'PopupBuilderAssetComponent',
    }}
  />
);
export { PopupBuilderAssetComponentController as PopupBuilderAssetComponent };
